import { useContext } from 'react'
import { Host } from '../context/AuthorizationContext'
import AuthorizationContext from '../context/AuthorizationContext'

/**
 * @deprecated use AuthorizationContext directly
 */
export default function useHost(): Host {
    const { host: currentHost } = useContext(AuthorizationContext)
    return currentHost
}
